import axios from 'axios'
import * as AxiosLogger from 'axios-logger'

const logConfig = {
  prefixText: 'API:Admin'
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_PORTAALI_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

if (process.env.NODE_ENV === 'development') {
  instance.interceptors.request.use(
    (request) => AxiosLogger.requestLogger(request, logConfig),
    (err) => AxiosLogger.errorLogger(err, logConfig)
  )
  instance.interceptors.response.use(
    (response) => AxiosLogger.responseLogger(response, logConfig),
    (err) => AxiosLogger.errorLogger(err, logConfig)
  )
}

export const setAuthorization = (token) => {
  instance.defaults.headers.common.Authorization = `Bearer ${token}`
}

/**
 * Admin
 */

export const getRoles = (filter) =>
  instance.post('/roles/list', {
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage
  })

export const upsertRole = (body) => instance.post('/roles/upsert', body)

export const deleteRole = (role) => instance.post('/roles/remove', role)

export const getPermissionsLayout = (body) => instance.post('/permissions/layout', body)

export const getRolePermissions = (role) =>
  instance.post('/permissions/list', { role })

export const upsertPermission = (body) => instance.post('/permissions/update', body)

/**
 * Email
 */

export const sendTestEmail = (email) =>
  instance.post('/email/sendTestEmail', { email })

/**
 * Storage
 */

export const getFiles = () => instance.post('/storage/GetFiles')

export const uploadFiles = (list) => instance.post('/storage/UploadFiles', { list })

export const deleteFiles = (list) => instance.post('/storage/DeleteFiles', { list })

/**
 * Content Manager
 */

export const getModels = () => instance.post('/contentType/GetModels')

export const upsertModels = (list) =>
  instance.post('/contentType/upsertModels', { list })

export const getContentTypeEntry = (entry, id) =>
  instance.post('/contentType/getEntry', { entry, id })

export const upsertContentTypeEntry = (entry, payload, action) =>
  instance.post('/contentType/upsertEntry', { entry, payload, action })

export const deleteContentTypeEntry = (entry, id) =>
  instance.post('/contentType/deleteEntry', { entry, id })

export const getContentTypeEntries = (entry, filter) =>
  instance.post('/contentType/getEntries', {
    entry,
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage
  })

/**
 * Quizz
 */

export const quizzGetUsers = (filter) =>
  instance.post('/quizz/GetUsers', {
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage
  })

export const quizzGetQuizzes = (filter) =>
  instance.post('/quizz/GetQuizzes', {
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage
  })

export const quizzGetUserGroups = (filter) =>
  instance.post('/quizz/GetUserGroups', {
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage
  })

export const quizzUpsertUsers = (list) =>
  instance.post('/quizz/UpsertUsers', { list })

export const quizzUpsertUserGroups = (list) =>
  instance.post('/quizz/UpsertUserGroups', { list })

export const quizzDeleteUsers = (list) => instance.post('/quizz/DeleteUsers', { list })

export const quizzDeleteUserGroups = (list) =>
  instance.post('/quizz/DeleteUserGroups', { list })

export const quizzDeleteQuizzes = (list) =>
  instance.post('/quizz/DeleteQuizzes', { list })

export const quizzGetQuizzLayout = (id) =>
  instance.post('/quizz/GetQuizzLayout', { id })

// TODO:
export const quizzUpsertQuizzLayout = (body) =>
  instance.post('/quizz/UpsertQuizzLayout', body)

// TODO:
export const quizzGetQuizzAnswers = (id) => instance.post('/quizz/GetAnswers', { id })

// TODO:
export const quizzGetPendingUsers = (id) =>
  instance.post('/quizz/GetPendingUsers', { id })

// TODO:
export const quizzGetTotalAnswers = () => instance.post('/quizz/GetTotalAnswers')

// TODO:
export const quizzGetCustomReport = (id) =>
instance.post('/quizz/CustomReport', { id })

export const quizzSendQuizz = (body) => instance.post('/quizz/SendQuizz', body)

/**
 * Slot Machine
 */

export const slotMachineGetBills = (filter) =>
  instance.post('/slotmachine/GetBills', {
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage
  })

export const slotMachineGetCompetitors = ({ store, filter }) =>
  instance.post('/slotmachine/GetCompetitors', {
    store,
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage
  })

export const slotMachineGetSwaps = ({ store, filter }) =>
  instance.post('/slotmachine/GetSwaps', {
    store,
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage
  })

export const slotMachineGetOverviewStats = (body) =>
  instance.post('/slotmachine/GetOverviewStats', body)

export const slotMachineGetOverviewSwaps = (body) =>
  instance.post('/slotmachine/GetOverviewSwaps', body)

export const slotMachineGenerateBills = (body) =>
  instance.post('/slotmachine/GenerateBills', body)

export const slotMachineTransferBills = (body) =>
  instance.post('/slotmachine/TransferBills', body)

export const slotMachineGetGameConfig = () =>
  instance.post('/slotmachine/GetGameConfig')

export const slotMachineSaveGameConfig = (body) =>
  instance.post('/slotmachine/SaveGameConfig', body)

/**
 * Hand Held
 */
export const handHeldGetStoresEndpoint = () =>
  instance.post('/handheld/GetStoresEndpoint')

export const handHeldUpdateStoresEndpoint = (body) =>
  instance.post('/handheld/UpdateStoresEndpoint', body)

/**
 * GTA
 */

export const gtaGetFormats = () => instance.post('/gta/formats')

export const gtaGetStores = (body) => instance.post('/gta/stores', body)

export const gtaGetDivisions = () => instance.post('/gta/divisions')

export const gtaGetDepartments = (body) => instance.post('/gta/departments', body)

export const gtaGetCategories = (body) => instance.post('/gta/categories', body)

/**
 * Apps
 */

export const getApps = (filter) =>
  instance.post('/apps/list', {
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage
  })

export const upsertApp = (body) => instance.post('/apps/upsert', body)

export const deleteApp = (app) => instance.post('/apps/delete', app)

export const checkIfBelongsToRegisteredApp = (body) =>
  instance.post('/apps/CheckIfBelongsToRegisteredApp', body)

/**
 * Offerts
 */

export const offertsGetBrochures = (body) => instance.post('/offerts/GetBrochures', body)

export const offertsGetBrochure = (body) => instance.post('/offerts/GetBrochure', body)

export const offertsUpsertBrochures = (list) =>
  instance.post('/offerts/UpsertBrochures', { list })

export const offertsDeleteBrochures = (list) =>
  instance.post('/offerts/DeleteBrochures', { list })
